import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import FileUploadCard from '../../../../components/FileManager/FileUploadCard';
import { useDispatch, useSelector } from 'react-redux';
import {
  deleteEmbryologyDayFile,
  setEmbryologyData,
  setEmbryologyDayFile,
} from '../../../../actions/embryologyActions';
import { toast } from 'sonner';
import {
  updateFileStatusUploaded,
  uploadPatientFileApi,
} from '../../../../api/patientApi';
import { deleteFileApi } from '../../../../api/fileApi';
import FileDocumentCard from '../../../../components/FileManager/FileDocumentCard';
import {
  saveEmbryologyFrozenTransferData,
  saveEmbryologyOocyteEmbryoRecord,
} from '../../../../api/embryologyApi';

const EmbryologyOocyteImageModal = ({
  show,
  onClose,
  index,
  day,
  isFT = false,
  setFilesHandler = null,
  setDeleteFileHandler = null,
}) => {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const patient = useSelector(
    (state) => state.embryologyReducer.selectedPatientData,
  );

  const data = useSelector((state) => state.embryologyReducer);
  let file;

  if (isFT) {
    file = data.embryoFrozenTransferDetails.thawingDetails[index].images;
  } else {
    file = data.oocyteEmbryo[`day${day}`].data[index].image;
  }

  const handleSave = async () => {
    try {
      setLoading(true);

      if (isFT) {
        const result = await saveEmbryologyFrozenTransferData(
          patient.patient.id,
          data.embryoFrozenTransferDetails,
        );

        dispatch(
          setEmbryologyData(
            `embryoFrozenTransferDetails.id`,
            result.data.result.id,
          ),
        );
      } else {
        const result = await saveEmbryologyOocyteEmbryoRecord(
          patient.patient.id,
          data.oocyteEmbryo,
        );
        console.log('handleSave', result);
        dispatch(setEmbryologyData(`oocyteEmbryo.id`, result.data.result.id));
      }

      toast.success('Data saved');
      setLoading(false);
      onClose();
    } catch (error) {
      console.error('Error saving data:', error);
      setLoading(false);
    }
  };

  console.log('file', file);
  let setUploadedFiles;

  if (isFT && setFilesHandler) {
    setUploadedFiles = (file) => {
      console.log('fileUploadedhere', file);
      if (file.length > 0) {
        setFilesHandler(file[0]);
      }
    };
  } else {
    setUploadedFiles = (file) => {
      dispatch(setEmbryologyDayFile(day, index, file));
    };
  }

  let fileTag;
  if (isFT) {
    fileTag = `Embryology-FrozenTransfer-${patient.patient.id}-${index}-`;
  } else {
    fileTag = `Embryology-Oocyte-${patient.patient.id}-${day}-${index}-`;
  }
  const handleUpload = async (file, patientId) => {
    if (!isFT && fileTag === 'Embryology-Oocyte-')
      return toast.error('Failed to upload file');
    if (isFT && fileTag === 'Embryology-FrozenTransfer-')
      return toast.error('Failed to upload file');
    if (!patientId) return toast.error('Patient not created');

    return new Promise((resolve, reject) => {
      try {
        setLoading(true);

        toast.promise(
          uploadPatientFileApi(
            file,
            patientId,
            'Patient',
            updateFileStatusUploaded,
            fileTag,
          ),
          {
            loading: 'Uploading file...',
            success: (data) => {
              setUploadedFiles({ ...data[0] });
              setLoading(false);
              return resolve(data);
            },
            error: (err) => {
              reject('Failed to upload docs');
            },
            duration: 800,
          },
        );
      } catch (err) {
        setLoading(false);
        toast.error('Failed to upload file');
      }
    });
  };

  const handleDeleteFile = async (file) => {
    try {
      await deleteFileApi('patient', patient.patient.id, file.id);
      if (isFT && setDeleteFileHandler) {
        setDeleteFileHandler();
      } else {
        dispatch(deleteEmbryologyDayFile(day, index));
      }
      toast.success('File deleted successfully');
    } catch (err) {
      toast.error('Error deleting file');
    }
  };
  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Upload Image</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <FileUploadCard
          setFiles={setFiles}
          setUploadedFiles={setUploadedFiles}
          files={Object.keys(file).length > 0 ? [file] : []}
          handleUpload={handleUpload}
          id={patient.patient.id}
          fileSelectionType="image/*"
          disabled={file.length > 0}
          fullWidth={true}
        />
        {file.map(
          (file) =>
            file && (
              <FileDocumentCard
                DocumentName={file.displayFileName}
                DocumentSize={(file.size / 1024).toFixed(2) + ' KB'}
                DocumentDate={new Date(file.updatedAt).toLocaleDateString()}
                ImageUrl={
                  file?.fileType?.includes('image')
                    ? file.presignedUrl
                    : undefined
                }
                handleDeleteFile={() => handleDeleteFile(file)}
                file={file}
                fileUniquePrefix={`patient-${patient.patient.id}`}
                fullWidth={true}
              />
            ),
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EmbryologyOocyteImageModal;
